import * as ko from 'knockout';

declare var DobryKantor: any;

export class BanksDoradcyFirmyComponent {
    index: ko.Observable<number>;
    timer: any;
    numberOfItems = 5;

    executeTimer() {
        this.timer = setTimeout(() => {
            this.index(this.index() % this.numberOfItems + 1);
            this.executeTimer();
        }, 10000);
    }

    constructor() {
        this.index = ko.observable(1);
        this.executeTimer();
    }

    isCurrentIndex(index: any) {
        return this.index() === index;
    }

    moveLeft() {
        clearTimeout(this.timer);
        let newIndex = (this.index() - 1) % this.numberOfItems;
        if (newIndex === 0) {
            newIndex = this.numberOfItems;
        }

        this.index(newIndex);
    }

    moveRight() {
        clearTimeout(this.timer);
        this.index(this.index() % this.numberOfItems + 1);
    }
}
